import { render, staticRenderFns } from "./form-success-external.vue?vue&type=template&id=dc180c96"
import script from "./form-success-external.vue?vue&type=script&lang=js"
export * from "./form-success-external.vue?vue&type=script&lang=js"
import style0 from "./form-success-external.vue?vue&type=style&index=0&id=dc180c96&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports